import axios from 'axios';
import React, { useState } from 'react';
import SubTitle from '../../../components/SubTitle/SubTitle';
import Title from '../../../components/Title/Title';
import CatCard from './CatCard/CatCard';


const Category = () => {
    const [category, setCategory] = useState([])
    // const {data: category = []} = useQuery({
    //     queryKey: ['category'],
    //     queryFn: async () => {
    //         const res = await fetch('')
    //         const data = await res.json()
    //         return data;
    //     }
    // })
    axios.get('https://resale-server-two.vercel.app/category')
    .then(function (response) {
      // handle success
      setCategory(response.data)
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    

    return (
        <div className='py-20 max-w-6xl mx-auto px-3'>
          <SubTitle>Check Our <span className='text-primary'>Car List</span></SubTitle>
          <Title>Our Category</Title>

          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-center mt-10 gap-10'>
            {category?.map((cat, i) => <CatCard key={i} cat={cat}></CatCard>)}
          </div>
        </div>
    );
};

export default Category;